import { render } from "./Subsidie.vue?vue&type=template&id=b00c1e0c&scoped=true"
import script from "./Subsidie.vue?vue&type=script&lang=js"
export * from "./Subsidie.vue?vue&type=script&lang=js"

import "./Subsidie.vue?vue&type=style&index=0&id=b00c1e0c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b00c1e0c"]])

export default __exports__